export default __webpack_public_path__ + "static/StyreneA-Bold-Web-b24ee16df4434565d7a71a5a20e9e9d2.woff2";